import { getNativeAudioParam } from '../helpers/get-native-audio-param';
import { renderInputsOfAudioParam } from '../helpers/render-inputs-of-audio-param';
export const connectAudioParam = (context, nativeOfflineAudioContext, audioParam, nativeAudioParam = getNativeAudioParam(audioParam)) => {
    return renderInputsOfAudioParam(context, audioParam, nativeOfflineAudioContext, nativeAudioParam);
};
//# sourceMappingURL=/build/es2018/helpers/connect-audio-param.js.map